// removed by extract-text-webpack-plugin
module.exports = {"container":"ErrorPanel__container___1bNnY layout__panel___vsQZV","errorMessage":"ErrorPanel__errorMessage___3QmWh"};


//////////////////
// WEBPACK FOOTER
// ./src/general-components/ErrorPanel.css
// module id = 752
// module chunks = 0